import actionTypes from '@/actions/actionTypes'
const initState = {
  isLogin: localStorage.getItem('loginToken') && localStorage.getItem('loginAccount'),
  isLoading: false,
  loginPhone: localStorage.getItem('loginPhone')
}

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLogin: true,
        isLoading: false
      }
    case actionTypes.START_LOGIN:
      return {
        ...state,
        isLoading: true
      }
    case actionTypes.LOGIN_FAILED:
      return {
        isLogin: false,
        isLoading: false
      }
    default:
      return state
  }
}